import { http, HttpResponse } from 'msw'

import { allVatReports } from 'app/mocks/data/reports/vat'

import { api, isNumeric } from 'app/utils/constants'

import type { InitialVatReportsRequest } from 'app/types/reports/vat'

export const getAllVatReports = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.reports.vat.LIST}`,
    ({ request }) => {
        const url = new URL(request.url)
        const limitQuery = url.searchParams.get('limit')
        const offsetQuery = url.searchParams.get('offset')

        // Pagination
        const limit = isNumeric(limitQuery) ? Number(limitQuery) : 10
        const offset = isNumeric(offsetQuery) ? Number(offsetQuery) : 0

        const limitArray =
            allVatReports.length > limit ? offset + limit : allVatReports.length

        const results = allVatReports.slice(offset, limitArray)

        const next =
            offset + results.length < allVatReports.length ? 'again' : undefined

        return HttpResponse.json<InitialVatReportsRequest>({
            next,
            results,
        })
    },
)
